import React from "react";

const BigPrizeAssignmentsList = React.lazy(() => import('src/pages/big_prize_assignments/BigPrizeAssignmentsList'));

const routes = [
    { path: '/dashboard/big-prize-assignments', name: 'Big Prize Assignments', element: BigPrizeAssignmentsList },
];

export default routes;
